import { styled } from "@mui/material";
import { ReactComponent as GenerateBill } from "assets/images/svg/generate-bill.svg";

export const GenerateBillIcon = styled(GenerateBill)(
  ({ theme, disabled }) => `
      fill: ${
        disabled ? "rgba(0, 0, 0, 0.26)" : theme.palette.primary.main
      };    
  `
);
